import './layout.less';

import classNames from 'classnames';
import * as React from 'react';
import SimpleReactLightbox from 'simple-react-lightbox';

import ArticleSearchBar from '_components/article-v3/ArticleSearchBar';
import NewCarPriceListsSearchBar from '_components/NewCarPriceLists/NewCarPriceListsSearchBar'
// import FooterLeadForm from '_components/FooterLeadForm';
import Footer from '_components/FooterV3/FooterV3';
import Header from '_components/HeaderV2';

function Layout({
  children,
  headerProps = {},
  mode,
  hideLeadForm = false,
  leadFormType,
  v3 = false,
  showArticleSearchBar = false,
  showNewCarPriceListsSearchBar = false,
  searchBarProps = {},
}) {
  return (
    <SimpleReactLightbox>
      <Header {...headerProps} />
      {showArticleSearchBar ? <ArticleSearchBar /> : null}
      {showNewCarPriceListsSearchBar
      ? <NewCarPriceListsSearchBar
      onChange={searchBarProps.onChange}
      onSubmit={searchBarProps.onSubmit}
      searchValue={searchBarProps.searchValue} />
      : null}
      {v3 ? (
        <main
          className={showArticleSearchBar ? 'pt-[117px] lg:pt-[71px]' : null}
        >
          {children}
        </main>
      ) : (
        <div className={classNames('content-wrapper', mode)}>
          <div className="app-content bg-white">{children}</div>
        </div>
      )}
      {/* {!hideLeadForm && <FooterLeadForm type={leadFormType} />} */}
      {!hideLeadForm ? <Footer /> : null}
    </SimpleReactLightbox>
  );
}

export default Layout;
